import React from 'react'
import { NavLink } from 'react-router-dom'
import { cn } from '../../utils/cn'
import {
  BarChart3,
  Server,
  RefreshCw,
  Settings,
  Plus,
  Users,
} from 'lucide-react'

const navItems = [
  {
    name: 'Dashboard',
    icon: BarChart3,
    href: '/',
    color: 'text-blue-500',
    bgColor: 'bg-blue-500/10',
  },
  {
    name: 'Providers',
    icon: Users,
    href: '/providers',
    color: 'text-green-500',
    bgColor: 'bg-green-500/10',
  },
  {
    name: 'Nodes',
    icon: Server,
    href: '/nodes',
    color: 'text-purple-500',
    bgColor: 'bg-purple-500/10',
  },
  {
    name: 'Sync',
    icon: RefreshCw,
    href: '/sync-logs',
    color: 'text-orange-500',
    bgColor: 'bg-orange-500/10',
  },
  {
    name: 'Settings',
    icon: Settings,
    href: '/settings',
    color: 'text-gray-500',
    bgColor: 'bg-gray-500/10',
  },
]

const MobileNav: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState('/')

  // Floating action button for quick actions
  const FloatingActionButton = () => (
    <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
      <button className="group relative">
        {/* Outer glow effect */}
        <div className="absolute -inset-2 bg-gradient-to-r from-primary-400 to-primary-600 rounded-full opacity-0 group-hover:opacity-50 blur transition-opacity duration-300" />

        {/* Main button */}
        <div className="relative w-12 h-12 rounded-full bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 active:scale-95">
          <Plus className="w-5 h-5 text-white" />
          <span className="sr-only">Quick Actions</span>
        </div>

        {/* Tooltip */}
        <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 px-3 py-1.5 bg-surface-light dark:bg-surface-dark border border-secondary-200 dark:border-secondary-700 rounded-lg shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
          <span className="text-xs font-medium text-secondary-900 dark:text-white">
            Quick Actions
          </span>
          <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-surface-light dark:bg-surface-dark border-b border-r border-secondary-200 dark:border-secondary-700 rotate-45" />
        </div>
      </button>
    </div>
  )

  return (
    <nav className="mobile-nav safe-bottom z-50">
      {/* Quick action button overlay */}
      <FloatingActionButton />

      {/* Navigation items */}
      <div className="flex items-center justify-around">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive = activeTab === item.href

          return (
            <NavLink
              key={item.name}
              to={item.href}
              onClick={() => setActiveTab(item.href)}
              className={({ isActive }) =>
                cn(
                  'flex flex-col items-center gap-1 p-2 rounded-xl transition-all duration-200',
                  'min-w-[60px]', // Minimum touch target
                  isActive
                    ? `${item.bgColor} ${item.color}`
                    : 'text-secondary-500 dark:text-secondary-400 hover:bg-secondary-100 dark:hover:bg-secondary-800'
                )
              }
            >
              <div className="relative">
                <Icon className="w-5 h-5" />
                {isActive && (
                  <div className="absolute -top-1 -right-1 w-2 h-2 bg-primary-500 rounded-full animate-pulse" />
                )}
              </div>
              <span className="text-xs font-medium truncate max-w-full">
                {item.name}
              </span>
            </NavLink>
          )
        })}
      </div>

      {/* Active indicator */}
      <div className="absolute top-0 left-0 w-full h-1">
        <div className="w-1/5 h-full bg-primary-500 rounded-b-full mx-auto" />
      </div>
    </nav>
  )
}

export default MobileNav